module.exports = __webpack_public_path__ + "carousel_04_img_05.png?8d11cd58f013c92e9c50f717b5b66682";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/carousel_04_img_05.png
// module id = 160
// module chunks = 0